import React, { FC, memo } from 'react'

import { Sparklines, SparklinesLine } from 'react-sparklines'

interface Props {
  sparklineData: number[]
  percentRate: number
}

export const SparkLine: FC<Props> = memo(({ sparklineData, percentRate }) => {
  return (
    <div style={{ width: '67px' }}>
      <Sparklines height={100} data={sparklineData} limit={sparklineData.length}>
        <SparklinesLine color={percentRate > 0 ? '#388ee3' : '#f6465d'} style={{ strokeWidth: 3 }} />
      </Sparklines>
    </div>
  )
})
